(function () {
  'use strict';

  function init(hero) {
    var bubbles = hero.querySelectorAll('.bm-hero__bubble');
    if (!bubbles.length) return;

    var minDur = parseFloat(getComputedStyle(hero).getPropertyValue('--bm-min-duration')) || 3.5;
    var maxDur = parseFloat(getComputedStyle(hero).getPropertyValue('--bm-max-duration')) || 6.5;
    var maxDelay = parseFloat(getComputedStyle(hero).getPropertyValue('--bm-max-delay')) || 4;

    bubbles.forEach(function (bubble) {
      var duration = minDur + Math.random() * (maxDur - minDur);
      var delay = Math.random() * maxDelay;
      var drift = (Math.random() - 0.5) * 4; // -2 to +2 user units
      bubble.style.setProperty('--duration', duration.toFixed(2) + 's');
      bubble.style.setProperty('--delay', delay.toFixed(2) + 's');
      bubble.style.setProperty('--drift', drift.toFixed(2) + 'px');
    });

    var observe = function () {
      if (!('IntersectionObserver' in window)) {
        hero.classList.add('is-animating');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          hero.classList.toggle('is-animating', entry.isIntersecting);
        });
      }, { threshold: 0.1 });
      io.observe(hero);
    };

    if (document.readyState === 'complete') observe();
    else window.addEventListener('load', observe, { once: true });
  }

  function start() {
    document.querySelectorAll('.bm-hero[data-bm-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
